// Map tool names to glyphs. Intentionally uses unicode / emoji rather
// than SF Symbols — we want a single source of truth that works in-browser
// too. Swap for an SVG set later if we want pixel fidelity.
const map: Record<string, string> = {
  bash: '▸',
  read: '📄',
  write: '✏️',
  edit: '✏️',
  multiedit: '✏️',
  webfetch: '🌐',
  websearch: '🔍',
  askuserquestion: '❓',
  exitplanmode: '📋',
  task: '◆',
  notebookedit: '📓',
  idle_prompt: '🌙',
  glob: '🔎',
  grep: '🔎',
  listdirectory: '📂',
}

export function toolIcon(name: string): string {
  return map[name.toLowerCase()] ?? '●'
}
